import React from 'react'
import { styled } from '@mui/material/styles'
import { Card } from '@mui/material'
import { boxShadow } from '@/constant'
import { NotificationLevel } from '@/types'
import { error, primary } from '@/constant/color'
import noti_org from '@/asset/img/noti_org.webp'
import { ImageIcon } from '@/icon'
import noti_app from '@/asset/img/noti_app.webp'

export const Base = styled('div')({
  display: 'grid',
  height: '100%',
  padding: '80px 28px',
  paddingBottom: '28px',
  placeItems: 'flex-start',
})

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
  width: '100%',
  height: '100%',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))

const levelColor: { [key in NotificationLevel]: string } = {
  high: error,
  medium: '#F7B500FF',
  low: '#0091FFFF',
}

const levelBackgournd: { [key in NotificationLevel]: string } = {
  high: 'rgba(255,102,93,0.1)',
  medium: 'rgba(247,181,0,0.1)',
  low: 'rgba(0,145,255,0.1)',
}

export const levelLetter: { [key in NotificationLevel]: string } = {
  high: '高',
  medium: '中',
  low: '低',
}

export const LevelTag = styled('div', {
  shouldForwardProp: (prop) => prop !== 'level',
})<{ level: NotificationLevel }>(({ level }) => ({
  display: 'inline-block',
  backgroundColor: levelBackgournd[level],
  color: levelColor[level],
  lineHeight: '24px',
  fontSize: '14px',
  width: '46px',
  textAlign: 'center',
  borderRadius: '4px',
}))

export const CatTag = styled('div')(() => ({
  display: 'inline-block',
  backgroundColor: '#52C41A1C',
  color: primary,
  lineHeight: '24px',
  fontSize: '12px',
  textAlign: 'center',
  padding: '0 8px',
  borderRadius: '4px',
}))

export const OrgTagIcon = () => (
  <ImageIcon src={noti_org} sx={{ width: '18px' }} />
)

export const AppTagIcon = () => (
  <ImageIcon src={noti_app} sx={{ width: '18px' }} />
)
